import React, { useEffect, useRef } from "react"
import Audio from "./Audio"
import File from "./File"
import Photo from "./Photo"
import Voice from "./Voice"
import styles from './Message.module.scss'

function stringToColor(str) {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;
    const saturation = 70 + (Math.abs(hash >> 8) % 30);   // بین 70 تا 100
    const lightness = 35 + (Math.abs(hash >> 16) % 30);   // بین 35 تا 65

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
const Message: React.FC<ChatMessageInputModel> = (props) => {
    return <>
        {props.position === 'center' ? <CenterComponent key={props.user.message.id} {...props} /> : props.position === 'right' ?
            <RightComponent key={props.user.message.id} {...props} /> : props.position === 'left' ?
                <LeftComponent key={props.user.message.id} {...props} /> : <></>}
    </>
}
const BaseComponent = ({ message, senderId, isBot, senderName, className, position, shwoSenderName }:
    UserChatMessageViewModel & { className: string, position: 'center' | 'left' | 'right', shwoSenderName?: boolean }) => {
    var messageHtml = '';
    const regLink = /(((\b(https?|ftp|file):\/\/)|www.)[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
    if (regLink.test(message.text.toLowerCase())) {
        if (message.text.includes('</a>'))
            messageHtml = message.text;
        else {
            messageHtml = message.text.replace(regLink, `<a target="_blank" href="$1">$1</a>`)
        }
    }
    else messageHtml = message.text;
    const refMessage = useRef<HTMLDivElement>(null)

    useEffect(() => {
        refMessage.current!.querySelectorAll('a').forEach(link => {
            if (!link.getAttribute('href')!.startsWith('http')) {
                link.href = '//' + link.getAttribute('href');
                link.target = '_blank'
            }
        });
    }, [])

    return <>
        <div className={`bg-white p-2 shadow-inner max-w-[80%] ${className}`}>
            {shwoSenderName && <h3 className="text-xs font-bold" style={{ color: stringToColor(senderId) }} >{senderName}</h3>}
            {message.attaches.length > 0 ? <div className="grid grid-cols-1 gap-2 py-2 text-black">
                {message.attaches.map((x, i) => {
                    if (x.fileExtension === 'audio/webm')
                        // return <Voice isLoading={x.isLoading} className="w-72  bg-white" key={i} fileAddress={x.fileAddress} fileName={x.name} />
                        return <Audio isLoading={x.isLoading} className="w-72 " key={i} fileAddress={x.fileAddress} fileName={x.name} />
                    else if (x.fileExtension.includes('audio'))
                        return <Audio isLoading={x.isLoading} className="w-72 " key={i} fileAddress={x.fileAddress} fileName={x.name} />
                    else if (x.fileExtension.includes('image'))
                        return <Photo isLoading={x.isLoading} key={i} fileName={x.name} fileAddress={x.fileAddress} />
                    return <File key={i} isLoading={x.isLoading} className="w-72" fileName={x.name} fileAddress={x.fileAddress} />
                })}
            </div> : <></>}
            <div dangerouslySetInnerHTML={{ __html: messageHtml }} ref={refMessage} className={`text-sm py-2 whitespace-pre-line ${styles.message}`}></div>
            <span className={`text-xs ${position === 'left' ? 'float-right' : 'float-left'} p-0 m-0`}>
                {new Date(message.insertDate).getFormattedTime()}
            </span>
            {position === 'right' ?
                <svg xmlns="http://www.w3.org/2000/svg"
                    className={`float-right ml-8 ${message.isSeen ? 'text-blue-500' : 'text-slate-400'}`} width={16} height={16} viewBox="0 0 16 16">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m1.75 9.75l2.5 2.5m3.5-4l2.5-2.5m-4.5 4l2.5 2.5l6-6.5">
                    </path>
                </svg> : <></>}
        </div>
    </>
}
const LeftComponent = ({ position, user, className, showSenderName }: ChatMessageInputModel) => {
    return <div id={user.message.id.toString()} className={`w-full block float-left`}>
        <BaseComponent {...user}
            shwoSenderName={showSenderName}
            className={`float-left rounded-r-md rounded-l-lg ${className ?? ''}`}
            position={position} />
    </div>
}
const RightComponent = ({ position, user, className, showSenderName }: ChatMessageInputModel) => {
    return <div id={user.message.id.toString()} className={`w-full  float-right block`}>
        <BaseComponent  {...user}
            shwoSenderName={showSenderName}
            position={position}
            className={`float-right rounded-l-md rounded-r-lg  ${className ?? ''}`} />
    </div>
}
const CenterComponent = ({ position, user, className, showSenderName }: ChatMessageInputModel) => {
    return <div id={user.message.id.toString()} className={`w-full `}>
        <BaseComponent   {...user}
            shwoSenderName={showSenderName}
            position={position}
            className={`mx-auto  p-2  bg-white break-all  ${className ?? ''}`} />
    </div>
}
export default Message;